import { RemotePauseRecurringPushNotification } from 'data/usecases';
import { PauseRecurringPushNotificationUseCaseInterface } from 'domain/usecases';
import { makeApiUrlPauseRecurringPushNotification } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makePauseRecurringPushNotification =
  (): PauseRecurringPushNotificationUseCaseInterface =>
    new RemotePauseRecurringPushNotification(
      makeApiUrlPauseRecurringPushNotification(),
      makeAxiosHttpClient(),
    );
